import { createRouter, createWebHistory } from 'vue-router';

import AdapterLoginLayout from '../layout/LoginLayout.vue';
import AdapterLoginPage from '../pages/Login/index.vue'
import LoginFailedPage from '../pages/LoginFailed/index.vue'

import TikuAdapterLayout from '../layout/TikuAdapterLayout.vue';
import TikuComponent from '../pages/TikuComponent/index.vue';
import IntelligentImport from '../pages/IntelligentImport/index.vue';
import UserList from '../pages/UserList/index.vue'
import LogList from '../pages/LogList/index.vue'
import RequestList from '../pages/RequestList/index.vue'
import RequestDashboard from '../pages/RequestDashboard/index.vue'
import RequestLog from '../pages/RequestLog/index.vue'
import AuditLog from '../pages/AuditLog/index.vue'
import UserDashboard from '../pages/UserDashboard/index.vue'
import ProviderManage from '../pages/ProviderManage/index.vue'
import UserSettings from '../pages/UserSettings/index.vue'
import SystemConfig from '../pages/SystemConfig/index.vue'
import Notebook from '../pages/Notebook/index.vue'
const routes = [
  {
    path: '/',
    name: 'loginlayout',
    component: AdapterLoginLayout,
    redirect: '/adapter/user-dashboard',
    children: [
      {
        path: 'login',
        name: 'adapterlogin',
        component: AdapterLoginPage
      },
      {
        path: 'login-failed',
        name: 'login-failed',
        component: LoginFailedPage
      }
    ]
  },
  {
    path: '/adapter',
    name: 'adapterlayout',
    component: TikuAdapterLayout,
    redirect: '/adapter/user-dashboard',
    children: [
      {
        path: 'user-dashboard',
        name: 'user-dashboard',
        component: UserDashboard,
      },
      {
        path: 'dashboard',
        name: 'dashboard',
        component: RequestDashboard,
      },
      {
        path: 'component',
        name: 'component',
        component: TikuComponent,
      },
      {
        path: 'import',
        name: 'import',
        component: IntelligentImport,
      },
      {
        path: 'userlist',
        name: 'userlist',
        component: UserList,
      },
      {
        path: 'loglist',
        name: 'loglist',
        component: LogList,
      }
      ,
      {
        path: 'requests',
        name: 'requests',
        component: RequestList,
      },
      {
        path: 'request-log',
        name: 'request-log',
        component: RequestLog,
      },
      {
        path: 'audit-log',
        name: 'audit-log',
        component: AuditLog,
      },
      {
        path: 'providers',
        name: 'providers',
        component: ProviderManage,
      },
      {
        path: 'system-config',
        name: 'system-config',
        component: SystemConfig,
      },
      {
        path: 'notebooks',
        name: 'notebooks',
        component: Notebook,
      },
      {
        path: 'settings',
        name: 'settings',
        component: UserSettings,
      }
    ]
  }

];

const router = createRouter({
  history: createWebHistory(),
  routes
});

export default router;
